/**
 * Soft status pill colors — matches State Insurance Filings SERFF Status (Filings.js getStatusStyle).
 */
export const PILL_STYLE = {
  teal: { background: 'var(--bg-teal-soft)', color: 'var(--c-teal-active)' },
  orange: { background: 'var(--bg-orange-soft)', color: 'var(--c-orange)' },
  purple: { background: 'var(--bg-purple-soft)', color: 'var(--c-purple-1)' },
  blue: { background: 'var(--bg-blue-soft)', color: 'var(--c-blue-1)' },
  empty: { background: 'var(--c-white)', color: 'var(--text2)' },
};

/** SERFF Status pill style (State Insurance Filings table). */
export function getSerffStatusPillStyle(status) {
  if (!status) return PILL_STYLE.empty;
  const s = String(status).toLowerCase();

  if (s.includes('approved') || s.includes('accepted')) {
    return PILL_STYLE.teal;
  }
  if (
    s.includes('objection')
    || s.includes('info')
    || s.includes('question')
    || s.includes('reject')
    || s.includes('disapproved')
    || s.includes('withdrawn')
    || s.includes('closed')
  ) {
    return PILL_STYLE.orange;
  }
  if (s.includes('review') || s.includes('pending')) {
    return PILL_STYLE.purple;
  }
  if (s.includes('assigned') || s.includes('submitted') || s.includes('created')) {
    return PILL_STYLE.blue;
  }

  return PILL_STYLE.blue;
}

export function getSentimentPillStyle(value) {
  const s = String(value || '').toLowerCase();
  if (s === 'positive') return PILL_STYLE.teal;
  if (s === 'negative') return PILL_STYLE.orange;
  if (s === 'neutral') return PILL_STYLE.blue;
  return PILL_STYLE.empty;
}

/** Matches AI Visibility Index chart quadrant label colors (--geo-quadrant-* on .geo-insights-visibility-card). */
export function getQuadrantPillStyle(quadrantKey) {
  switch (quadrantKey) {
    case 'niche':
      return { color: 'var(--geo-quadrant-niche)', background: 'var(--geo-quadrant-niche-bg)' };
    case 'leaders':
      return { color: 'var(--geo-quadrant-leaders)', background: 'var(--geo-quadrant-leaders-bg)' };
    case 'lowConversion':
      return { color: 'var(--geo-quadrant-low-conversion)', background: 'var(--geo-quadrant-low-conversion-bg)' };
    case 'lowPerformance':
    default:
      return { color: 'var(--geo-quadrant-low-performance)', background: 'var(--geo-quadrant-low-performance-bg)' };
  }
}
